<template>
    <div
        v-if="tips.hasOwnProperty(cartItem.id) && tips[cartItem.id].length > 0"
        class="inline-block rounded-md bg-amber-50 border border-amber-100 px-4 py-2 text-sm sm:text-base mt-2 space-y-2"
    >
        <button
            type="button"
            v-for="tip in tips[cartItem.id]"
            :key="tip.id"
            @click="
                increaseCartItemQuantity(
                    cartItem,
                    tip.recommended_quantity_change,
                    shippingTimeId,
                )
            "
            class="flex items-center focus:outline-none"
        >
            <div class="shrink-0 text-amber-400">
                <LoadingIcon v-if="loading" class="h-5 w-5 mr-2" />
                <LightBulbIcon v-else class="h-5 w-5" aria-hidden="true" />
            </div>
            <div
                class="ml-3 text-sm text-left text-amber-700 hover:text-amber-800"
            >
                <p>
                    {{ tip.name }}
                </p>
            </div>
        </button>
    </div>
</template>

<script setup lang="ts">
import { LightBulbIcon } from "@heroicons/vue/outline";
import { useCartItem } from "../../functions/useCartItem";
import LoadingIcon from "../LoadingIcon.vue";

// NOTE(4f): the Options-API prop declared `default: null`; in `<script setup>`
// an absent optional `number` prop is `undefined`, which is falsy exactly like
// `null`. `useCartItem` guards `shippingTimeId` with `if (shippingTimeId)`, so the
// null→undefined swap is behavior-identical and keeps the param type clean.
defineProps<{
    cartItem?: any;
    shippingTimeId?: number;
    tips?: any;
}>();

const { loading, increaseCartItemQuantity } = useCartItem();
</script>
